import React, { Component } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import {SensorNames} from './MeterTypes'

export default class SensorTypeDropdown extends Component {
  constructor(props) {
    super(props);

    this.apiValues = props.types ??[]
    this.state = {
      options: SensorNames(props.types),
      value: this.props?.value ?? "Select One"
    }
    this.clickedItem = this.clickedItem.bind (this)
  }
  componentDidUpdate(prevProps) {
    //console.log ("fix that dropdown", prevProps, this.props)
    this.apiValues = this.props.types ?? []
    if (this.state.value !== (this.props?.value ?? "Select One") || this.props.types.length !== prevProps.types.length)
      this.setState({value: this.props?.value ?? "Select One", options: SensorNames(this.props.types)})
  }
  clickedItem (index) {
    this.setState({value: this.state.options[index]})
    if (this.props?.onClick)
      this.props.onClick (this.state.options[index], this.props?.types[index])
  }
  render () {
    return(
      <span>Now Using&nbsp;
      <DropdownButton id="dropdown-basic-button" title={this.state.value} className="annoying-dropdown" disabled={true}>
      {this.apiValues.map((v, index) => 
        <Dropdown.Item onClick={()=>this.clickedItem(index)} key={index}>{this.state.options[index]}</Dropdown.Item>)}
      </DropdownButton>
      </span>
    )
  }    
}
